export default __webpack_public_path__ + "static/Studio-to-Sea-Homepage-Banner-Desktop-15e76305e32266c4e99bb835b5ece79b.webp";